export default function ViewerTableSkeleton() {
  return (
    <div className='vp-skeleton'>
      <div className='vp-skeleton-list'>
        {[...Array(6)].map((_, i) => (
          <div className='vp-skeleton-row' key={i}>
            <div
              className='vp-skeleton-cell shimmer'
              style={{ width: '50%' }}
            />
            <div
              className='vp-skeleton-cell shimmer'
              style={{ width: '20%' }}
            />
            <div
              className='vp-skeleton-cell shimmer'
              style={{ width: '20%' }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
